import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

export default function ViewLeaveSummary({ closeModal, alert, user }) {
  console.log(user);
  return (
    <React.Fragment>
      <div className="">
        <div className="form-group row">
          <div className="row m-auto">
            <div class="col-md-12">
              <h4 style={{ color: "#000" }}>Leave Summary</h4>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th scope="col">Leave type</th>
                    <th scope="col">Days remaining</th>
                  </tr>
                </thead>
                <tbody>
                  {user.leaves.map((leave, i) => (
                    <tr key={i}>
                      <td>{leave.leave_type}</td>
                      <td>{leave.days_remaining}</td>
                    </tr>
                  ))}
                  <td>{user.leave_type}</td>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <hr />

        <div className="form-group row">
          <div className="col">
            <button
              type="button"
              className="btn btn-danger btn-sm btn btn-block"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/modals/view_leave_summary.js